import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Button from 'material-ui/Button'
import IconButton from 'material-ui/IconButton'
import ArrowForward from 'material-ui-icons/ArrowForward'
import Card, {
  CardContent,
  CardActions
} from 'material-ui/Card'
import CityMetric from '../CityMetric'
import { Helmet } from 'react-helmet'
import analytics from '../../utils/analytics'

type Props = {
  name: string,
  averageAttendanceRate: number,
  highestAttendanceRate: {
    councillorName: string,
    title: string,
    attendanceRate: number
  },
  mostMeetingsAttended: {
    councillorName: string,
    title: string,
    numberOfMeetings: number
  },
  pictureUrl?: string
}

class CityCouncilPage extends Component<Props> {
  componentDidMount () {
    analytics.track('City Council Viewed')
  }

  render() {
    const {
      name,
      averageAttendanceRate,
      mostMeetingsAttended,
      highestAttendanceRate
    } = this.props

    return (
      <div className='pa2'>
        <Helmet>
          <title>{name} City Council Performance</title>
          <meta
            name='description'
            content={`The city council of ${name} has an average attendance of ${averageAttendanceRate}%`}
          />
        </Helmet>
        <Card className='center mw7 mt2'>
          <CardContent>
            <div className='gray f4 mb2 tc'>average attendance rate</div>
            <div className='tc f1'>{averageAttendanceRate.toFixed(2)}%</div>

            <CityMetric
              title='most meetings attended'
              councillorName={mostMeetingsAttended.councillorName}
              councillorWard={mostMeetingsAttended.title}
              metricLabel='meetings'
              metricValue={mostMeetingsAttended.numberOfMeetings}
            />

            <CityMetric
              title='highest attendance rate'
              councillorName={highestAttendanceRate.councillorName}
              councillorWard={highestAttendanceRate.title}
              metricValue={`${highestAttendanceRate.attendanceRate}%`}
            />
          </CardContent>

          <CardActions>
            <Button
              component={Link}
              to='/toronto/councillors'
            >
              See more
              <IconButton>
                <ArrowForward />
              </IconButton>
            </Button>
          </CardActions>
        </Card>
      </div>
    )
  }
}

export default CityCouncilPage



// WEBPACK FOOTER //
// ./src/components/CityCouncilPage/CityCouncilPage.js